// WP-19 — ONE config for every public contact identity.
// Before this module public contact details were hand-copied across the footer, Landing strip
// and Contact page, and the email identity forked by surface (hello@ in the footer, support@
// in the Landing strip, both on /contact). Rules:
//   • The footer and Contact page show all three verified phone lines.
//   • WhatsApp remains attached to the primary sales number.
//   • Purpose-specific help is also routed by the labelled email channels on /contact.
//   • sales@ and support@ are the two advertised inboxes. hello@ is retired from the UI —
//     keep it alive as a forwarding alias server-side (flagged in the WP report).
export const SALES_PHONE = Object.freeze({ display: "+91 99404 68540", tel: "+919940468540" });
export const ALL_PHONES = Object.freeze([
  SALES_PHONE,
  Object.freeze({ display: "+91 63660 97912", tel: "+916366097912" }),
  Object.freeze({ display: "+91 63660 97712", tel: "+916366097712" }),
]);
export const WHATSAPP_NUMBER = "919940468540";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const SALES_EMAIL = "sales@vidyapeeth360.com";
export const SUPPORT_EMAIL = "support@vidyapeeth360.com";
// The vulnerability-disclosure inbox. It is deliberately NOT support@ — the published Terms
// (core/legal_defaults.py) and the Help Center both name this address as the security channel,
// and a good-faith report must land where it is triaged as security.
export const SECURITY_EMAIL = "security@helprevx.com";
export const REGISTERED_ADDRESS = "No. 7, R K Nagar, Padmapur, Rayagada, Odisha 765026, India";
